<template>
  <div class="container">
    <van-nav-bar :title="lang.vid_title" left-arrow @click-left="prev" :right-text="lang.keyCon" @click-right="saveVid('warp')" class="nav_bar" />
    <div class="v_box">
      <div class="v_coverbox">
        <div class="v_cover">
          <div>{{ lang.vid_cover }}</div>
          <van-uploader :max-size="20971520" :after-read="onRead">
            <van-button type="primary" class="btn">{{ lang.up_title }}</van-button>
          </van-uploader>
        </div>
        <div v-for="(item, index) in preview" :key="index" class="up-img">
          <van-icon name="close" class="el-icon-close" @click="delVideoImage" />
          <img :src="item.localPath || item.defaultImagePath + '?x-oss-process=style/' + '150xauto_f'" />
          <span v-if="item.localPath && !item.defaultImagePath" class="up-loading">{{ lang.imgloading }}</span>
          <span v-else-if="!item.localPath && !item.defaultImagePath" class="up-loading"> {{ lang.imgfaile }} {{ lang.imgdel }} </span>
          <!-- <span v-else-if="!item.defaultImagePath" class="up-loading"> 图片加载中 </span> -->
        </div>
        <div class="v_link">
          <div class="title_link">{{ lang.up_vid }}</div>
          <input class="v_content" @input="setVlin" v-model="videoPath" type="text" />
          <div class="err_link">{{ lang.up_yfvid }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//基本逻辑应该是这样的
// 如果想要vfor循环出来的,可以放在两个数组进行传递!!最后点击savepic的时候可以同志
import { Toast, Dialog, Area, Uploader } from 'vant';
import draggable from 'vuedraggable';
import lang from './../../../common/language/post';
import pub from './../../../common/public.js';
const conf = require('./../../../common/js/_conf'); //判断环境
export default {
  data() {
    return {
      temp: [],
      lang,
      imgQueue: {}, //图片字典
      preview: [], // 接口返回的预览图,要用的
      isUpLoading: false,
      curQueue: {},
      videoPath: '',
    };
  },
  //  展示用preview,保存的时候将preview的值付给videos,然后在created里面将preview赋值,进行页面的展示
  // preview应该一直是一个的状态
  created() {
    // 引入图片上传插件
    let zipImg = document.createElement('script');
    zipImg.type = 'text/javascript';
    zipImg.src = '//static.centanet.com/public/js/oss-upload.js';
    document.body.appendChild(zipImg);
    zipImg.onload = () => this.initZipImg();
    this.pub.getDictionary().then((res) => {
      this.imgTypeBase = [...res.PropertyImageType.children];
    });
    //  console.log("进入我这个页面的",this.store.state.videos)
    // 当仅有链接没有图片的时候 防止出现页面显示裂开图片
    if (this.store.state.videos.length !== 0) {
      if (this.store.state.videos[0].defaultImagePath && this.store.state.videos[0].defaultImagePath !== '' && this.store.state.videos[0].defaultImagePath !== null) {
        this.preview = JSON.parse(JSON.stringify(this.store.state.videos));
        this.videoPath = this.preview[0].videoPath;
      } else {
        this.videoPath = this.store.state.videos[0].videoPath;
      }
    } else {
      this.preview = JSON.parse(JSON.stringify(this.store.state.videos));
    }
    // console.log("videospreview",this.preview)
  },
  methods: {
    delVideoImage() {
      this.preview = [];
    },
    initZipImg() {
      var bucket = 'house730-uat-files';
      if (conf.env_type == 3 || conf.env_type == 4) {
        bucket = 'house730-files';
      } else {
        bucket = 'house730-uat-files';
      }
      this.$upload = new $upload({
        // 可选参数
        maxWidth: 1920, //最大压缩宽度(仅针对图片文件生效)
        maxHeight: 1920, //可选参数,最大压缩高度(仅针对图片文件生效)
        zipLimit: 3000, //压缩上传阈值，单位KB， 超过此大小则压缩，否则原图上传(仅针件图片文件生效)
        // 必选参数 OSS配置
        region: 'oss-accelerate',
        accessKeyId: 'LTAI4FndXDCKXK4tEMRgRBBv',
        accessKeySecret: 'TKLkHAOMxiDNf1PjoGX7KguYmeqJgx',
        bucket,
        // bucket: 'house730-files'
      });
    },
    prev() {
      this.$router.go(-1);
    },
    setVlin(e) {
      this.videoPath = e.target.value;
    },
    onRead(value) {
      this.preview = [];
      if (value.constructor === Object) {
        value = [{ ...value }];
      }
      value.forEach((item, index) => {
        if (!item.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
          Toast(this.lang.fileError);
          return;
        }
        // 本地临时图片 但是如何把dataurl的值对应上给了defaultImagePath,pc端我记得可是就写了一个
        value[index] = item.file;
        // 时间戳+id生成唯一标识符
        value[index].id = new Date().getTime() + index;
        // 生成本地临时图片
        const windowURL = window.URL || window.url || window.webkitURL;
        const dataimgurl = windowURL.createObjectURL(item.file);
        value[index].localPath = dataimgurl;
        this.imgQueue[item.file.id] = item;
        // console.log("this.imgquene",this.imgQueue)
        // 这可能会置空,如果先填写连接,然后又一次放图片
        this.preview.push({
          localPath: dataimgurl,
          defaultImagePath: null,
          videoPath: '',
        });
      });
      if (!this.isUpLoading) {
        this.goUp();
      }
    },
    // 预览图 guess大图
    // 上传图片
    async goUp() {
      let _this = this;
      if (Object.keys(this.imgQueue).length > 0) {
        try {
          // ---------------this-----------------
          this.curQueue.id = Object.keys(this.imgQueue)[0];
          this.curQueue.file = this.imgQueue[this.curQueue.id].file;
          _this.isUpLoading = true;
          // console.log("file",_this.curQueue.file)
          const result = await _this.$upload.go(_this.curQueue.file);
          //上传成后删除列队中的文件
          //队列是photo组件上传多张图片的时候,上一张还没上传完,下一章在上传,为了不影响观感,会提示在队列中
          delete _this.imgQueue[_this.curQueue.id];
          if (conf.env_type == 3 || conf.env_type == 4) {
            result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
          } else if(conf.env_type == 2 && process.env.VUE_APP_TYPE == 'uat'){
            result.url = result.url.replace('house730-uat-files.oss-accelerate.aliyuncs.com', 'uatimg.house730.com.cn').replace('https://', 'http://');;
          }else {
            result.url = result.url.replace('house730-uat-files.oss-accelerate.aliyuncs.com', 'uatimg.house730.com.cn');
          }
          // console.log("localpath",_this.curQueue.file.localPath)
          if (_this.preview[0].localPath === _this.curQueue.file.localPath) {
            delete _this.preview[0].localPath;
            _this.preview[0].defaultImagePath = result.url;
          }
          //  console.log("赋值了URL的preview",this.preview)
          _this.goUp();
        } catch (err) {
          // console.log("catch")
          let count = _this.curQueue.file.count || 0;
          count += 1;
          _this.curQueue.file.count = count;
          //错误次数小于5次, 继续重试
          if (count <= 5) {
            _this.goUp();
          } else {
            delete _this.imgQueue[_this.curQueue.id];
            //多次上传失败,删除错误图片,继续上传剩余图片
            _this.preview.forEach((e, i) => {
              if (e.localPath === _this.curQueue.file.localPath) delete _this.preview[i].localPath;
            });
            _this.goUp();
          }
        }
      } else {
        this.isUpLoading = false;
        this.curQueue = {};
      }
    },
    saveVid(type) {
      if (type == 'warp') {
        // 对视频链接进行校验
        if (this.videoPath !== '') {
          var reg4 = new RegExp('^https://(www[.]youtube[.]com|www[.]facebook[.]com|fb[.]watch|youtu[.]be|m[.]youtube[.]com|m[.]facebook[.]com)/.*');
          // console.log("match",this.videoPath)
          if (!reg4.test(this.videoPath)) {
            Toast(this.lang.up_yfvid);
            return;
          }
        }
        let temp = [];
        if (this.preview.length == 0) {
          if (this.videoPath !== '') {
            // this.preview.push({
            // videoPath: this.videoPath,
            // });
            temp.push({
              videoPath: this.videoPath,
            });
          }
        } else {
          this.preview[0].videoPath = this.videoPath;
          temp = this.preview.filter((item) => {
            // 如果有localPath属性 说明没有上传成功  || imagePath为null说明上传失败 符合条件的可以上传
            return !item.hasOwnProperty('localPath');
          });
        }
        // temp=this.previews
        this.store.commit('setVideoimg', temp);
        window.stop();
        this.$router.go(-1);
      }
    },
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    // draggable
  },
};
</script>

<style scoped lang="scss">
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.v_box {
  width: 100%;
  height: 100%;
  padding: 0, 16px !important;
}
.v_coverbox {
  margin-top: 40px;
  margin-left: 20px;
  margin-right: 20px;
}
.v_cover {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.btn {
  margin-left: 12px;
  margin-top: -5px;
  height: 26px;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  font-weight: 400;
  border: 1px solid #ff1216;
  background-color: #ff1216;
  color: #fff;
}
.up-img {
  width: 100%;
  height: 241px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    margin-top: 17px;
  }
  .el-icon-close {
    font-size: 26px;
    position: absolute;
    right: -9px;
    top: 6px;
    background-color: #4c4c4c;
    color: #fff;
    border-radius: 50%;
  }
  .up-loading {
    font-size: 22px;
    position: absolute;
    left: 0;
    top: 16px;
    width: 100%;
    height: 241px;
    line-height: 241px;
    background: rgba(0, 0, 0, 0.4);
    box-sizing: border-box;
  }
}
.vid_image {
  width: 330px;
  height: 170px;
  margin-top: 12px;
}
.v_link {
  margin-top: 60px;
}
.title_link {
  text-align: left;
}
.v_content {
  border: none;
  border-bottom: 1px solid #797979;
  width: 100%;
  height: 38px;
  padding-left: 0px;
  background: #fff;
}
.err_link {
  margin-top: 12px;
  text-align: left;
  color: #e92737;
}
.v_describe {
  width: 100;
  height: 40px;
  border-bottom: 1px solid gray;
}
.nav_bar {
  border: 0;
}
</style>
